import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Hero from '@/components/feature/Hero';
import WhatIsSection from '@/components/feature/WhatIsSection';
import PopularCategories from '@/components/feature/PopularCategories';
import ValueProposition from '@/components/feature/ValueProposition';
import HowItWorks from '@/components/feature/HowItWorks';
import SEOArticleCluster from '@/components/feature/SEOArticleCluster';
import Testimonials from '@/components/feature/Testimonials';
import SafetySection from '@/components/feature/SafetySection';
import FinalCTA from '@/components/feature/FinalCTA';
import Footer from '@/components/feature/Footer';

export default function Home() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'itaobuy.living',
      url: 'https://itaobuy.living',
      description: 'Itaobuy Spreadsheet is a structured product sourcing system that helps buyers browse, compare, and purchase products from Chinese marketplaces through an organized spreadsheet format.',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://kaspreadsheet.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    });
    document.head.appendChild(script);

    const orgScript = document.createElement('script');
    orgScript.type = 'application/ld+json';
    orgScript.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'itaobuy.living',
      url: 'https://itaobuy.living',
      sameAs: ['https://kaspreadsheet.com'],
    });
    document.head.appendChild(orgScript);

    return () => {
      document.head.removeChild(script);
      document.head.removeChild(orgScript);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <WhatIsSection />
        <PopularCategories />
        <ValueProposition />
        <HowItWorks />
        <SEOArticleCluster />
        <Testimonials />
        <SafetySection />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}